import I18n from 'i18n-js'
import callApi from 'services'
import { loginSuccess } from '../store/actions/userActions'
import { store } from '../store/configureStore'
import { errorToast, successToast, loadingToast } from '../utils/toast'
import { toast } from 'react-toastify'
import { filtersToUrlParams } from './index'

const switchToGestionnaire = (groupId) => {
  return callApi('users/switch', 'POST', JSON.stringify({ groupId }))
    .then((res) => {
      window.dispatchEvent(new Event('storage'))
      store.dispatch(loginSuccess(res, true))
      // dispatch localstorage change evet
      window.location.href = '/?gestionnaireChange=1'
    })
    .catch(() => {
      errorToast('Une erreur est survenue')
    })
}

const getUsersList = (params) => {
  if (params) {
    params = `?${filtersToUrlParams(params)}`
  } else {
    params = ''
  }
  return callApi(`users${params}`, 'GET')
}

const syncUserListWithLdap = (params) => {
  return callApi(`users?${params ? filtersToUrlParams(params) : ''}`, 'PUT')
}

const syncUserListWithCRM = (params) => callApi(`sync${params ? filtersToUrlParams(params) : ''}`, 'GET')

const updateUser = (user) => {
  return callApi(`users/${user.id}`, 'PUT', JSON.stringify(user))
}

const deactivateUser = (userId) => {
  return callApi(`users/${userId}/deactivate`, 'POST', JSON.stringify({}))
    .then((response) => {
      successToast(I18n.t('DesactivationSuccess'))
      return response
    })
    .catch(() => {
      errorToast(I18n.t('DesactivationError'))
    })
}

const importCsvUserRelations = (csv, params, isDryRun) => {
  const queryParams = { ...params, ...(isDryRun ? { isDryRun: true } : {}) }
  const formData = new FormData()
  formData.append('file', csv)
  const toastId = loadingToast(I18n.t('ImportInProgress'))
  return callApi(`import/users/files?${filtersToUrlParams(queryParams)}`, 'POST', formData, undefined, true).finally(() => {
    toast.dismiss(toastId)
  })
}

export default {
  getUsersList,
  syncUserListWithLdap,
  updateUser,
  importCsvUserRelations,
  switchToGestionnaire,
  syncUserListWithCRM,
  deactivateUser,
}
